/* ÁNIMO Cart Controller. Spec §5.14, §6. */
(() => {
  const FREE_SHIPPING_CENTS = 100000;
  const DRAWER_SECTION_ID = 'animo-cart-drawer';

  const drawer = () => document.getElementById('animo-cart-drawer');
  const overlay = () => document.getElementById('animo-cart-overlay');
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  let lastFocused = null;

  function openDrawer() {
    const d = drawer();
    if (!d) return;
    lastFocused = document.activeElement;
    d.classList.add('animo-cart--open');
    overlay()?.classList.add('animo-cart-overlay--open');
    document.body.classList.add('animo-cart-locked');
    const first = d.querySelector(FOCUSABLE);
    if (first) first.focus();
  }

  function closeDrawer() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('animo-cart--open');
    overlay()?.classList.remove('animo-cart-overlay--open');
    document.body.classList.remove('animo-cart-locked');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  async function refreshDrawer() {
    try {
      const res = await fetch(`/?sections=${DRAWER_SECTION_ID}`);
      if (!res.ok) throw new Error('Section render failed');
      const sections = await res.json();
      const html = sections[DRAWER_SECTION_ID];
      if (!html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newDrawer = parsed.querySelector('#animo-cart-drawer');
      const oldDrawer = drawer();
      if (newDrawer && oldDrawer) {
        // Preserve open state — copy children, not the wrapper itself
        oldDrawer.innerHTML = newDrawer.innerHTML;
      }
    } catch (err) {
      console.error('[AnimoCart] Drawer refresh failed', err);
    }
  }

  async function addToCart(formData) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Add to cart failed');
    }
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!res.ok) throw new Error('Cart change failed');
    return res.json();
  }

  async function convertLineToSub(key, sellingPlanId) {
    // Shopify supports updating selling_plan via /cart/change.js with `selling_plan` param
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, selling_plan: sellingPlanId }),
    });
    if (!res.ok) throw new Error('Sub conversion failed');
    return res.json();
  }

  // ============ event delegation ============
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-animo-cart-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }
    const closeBtn = e.target.closest('[data-animo-cart-close]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    const stepBtn = e.target.closest('[data-cart-step]');
    if (stepBtn) {
      e.preventDefault();
      const line = stepBtn.closest('[data-cart-line]');
      const key = line?.dataset.cartLine;
      const qty = parseInt(line?.querySelector('[data-cart-qty]').value, 10) || 1;
      const step = parseInt(stepBtn.dataset.cartStep, 10);
      const next = Math.max(0, qty + step);
      changeLine(key, next).then(refreshDrawer).catch(err => console.error('[AnimoCart]', err));
      return;
    }
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      const line = removeBtn.closest('[data-cart-line]');
      const key = line?.dataset.cartLine;
      if (key) changeLine(key, 0).then(refreshDrawer).catch(err => console.error('[AnimoCart]', err));
      return;
    }
    const upsellSub = e.target.closest('[data-cart-upsell-sub]');
    if (upsellSub) {
      e.preventDefault();
      const key = upsellSub.dataset.cartUpsellSub;
      const sellingPlanId = upsellSub.dataset.sellingPlanId;
      if (key && sellingPlanId) convertLineToSub(key, sellingPlanId).then(refreshDrawer).catch(err => console.error('[AnimoCart]', err));
      return;
    }
  });

  // ============ ATC form interception ============
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-animo-atc]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) {
      btn.dataset.originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Añadiendo…';
    }
    try {
      await addToCart(new FormData(form));
      await refreshDrawer();
      openDrawer();
    } catch (err) {
      console.error('[AnimoCart] ATC failed', err);
      alert('No pudimos añadir el producto. Intenta de nuevo.');
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = btn.dataset.originalText;
      }
    }
  });

  // ============ rewire Horizon cart triggers ============
  // Horizon ships a cart icon that opens its own drawer. We rewire those
  // buttons to open the ÁNIMO drawer instead, while preserving keyboard /
  // screen-reader semantics.
  document.addEventListener('click', (e) => {
    const horizonTrigger = e.target.closest('[data-cart-drawer-open], a[href$="/cart"]');
    if (!horizonTrigger) return;
    // Allow modifier-clicks (open in new tab) and skip if inside our own drawer
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (horizonTrigger.closest('#animo-cart-drawer')) return;
    e.preventDefault();
    openDrawer();
  }, true);

  // ============ ESC closes ============
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer()?.classList.contains('animo-cart--open')) closeDrawer();
  });

  // ============ expose ============
  window.AnimoCart = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer, FREE_SHIPPING_CENTS };
})();
